import api from './api';
import { toast } from 'react-toastify';
import {
  FIELDS_POS_PAG_CONSULTA,
  FIELDS_ACOMPANHAR_SOLICITACAO,
  COLUMNS_ACOMPANHAR_SOLICITACAO,
  FIELDS_RELATORIO,
  FIELDS_RELATORIO_FATURAMENTO,
  FIELDS_RELATORIO_PROTOCOLO,
  FIELDS_RELATORIO_PROTOCOLO_REALIZADO_SIM,
  FIELDS_RELATORIO_PROTOCOLO_REALIZADO_NAO,
  COLUMNS_RELATORIO_FATURAMENTO,
  COLUMNS_RELATORIO_PROTOCOLO,
  FIELDS_RELATORIOS_REGISTRO_CONTRATO_GERAL,
  COLUMNS_REGISTRO_CONTRATO_GERAL,
  COLUMNS_ANALITICO_POS,
  FIELDS_DASHBOARD,
  FIELDS_ANALISE_DEVOLUTIVA,
  COLUMNS_ANALISE_DEVOLUTIVA,
  COLUMNS_ANALITICO_POS_CONTRATO_INEXISTENTE,
  FIELDS_RELATORIO_CONTRATOS_RECEPCIONADOS,
  COLUMNS_RELATORIO_CONTRATOS_RECEPCIONADOS,
  FIELDS_RELATORIO_PROCESSAMENTO_CARGAS,
  COLUMNS_RELATORIO_PROCESSAMENTO_CARGAS,
  COLUMNS_POS_PAG_RETIRADA_DE_ORIGINAL,
  COLUMNS_POS_PAG_RETIRADA_DE_ORIGINAL_2,
  FIELDS_POS_PAG_RETIRADA_DE_ORIGINAL,
  FIELDS_POS_PAG_SOLICITACAO_DOCUMENTOS,
  COLUMNS_POS_PAG_SOLICITACAO_DOCUMENTOS,
  FIELDS_POS_PAG_APROVADOR_SOLICITACAO,
  COLUMNS_POS_PAG_APROVADOR_SOLICITACAO
} from '../constants/pospagMocks';


export const getColumnsRelatorios = async (tipoRelatorio) => {
  try {
    if (tipoRelatorio === 'contratoGeral') {
      return COLUMNS_REGISTRO_CONTRATO_GERAL;
    }
  } catch (error) {
    return [];
  }
};

export const exportRelatorio = async (values, type) => {
  const { relatorioPosPag, tipoRelatorio, ...valuesWithoutRelatorioPosPag } = values

  if (relatorioPosPag && !tipoRelatorio) values = {
    ...valuesWithoutRelatorioPosPag,
    tipoRelatorio: relatorioPosPag
  }

  try {
    const client = await api('consulta');
    const { data } = await client.post(
      `/relatorioPosPag/exportarRelatorio?type=${type}`,
      values,
      { responseType: 'arraybuffer' }
    );
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar exportar o arquivo Excel.');
  }
};

export const getColumns = (type) => {
  try {
    return {
      acompanharSolicitacao: COLUMNS_ACOMPANHAR_SOLICITACAO,
      faturamento: COLUMNS_RELATORIO_FATURAMENTO,
      contratoGeral: COLUMNS_REGISTRO_CONTRATO_GERAL,
      'analise-retorno-detran': COLUMNS_ANALISE_DEVOLUTIVA,
      protocolo: COLUMNS_RELATORIO_PROTOCOLO,
      contratosRecepcionados: COLUMNS_RELATORIO_CONTRATOS_RECEPCIONADOS,
      processamentoDeCargas: COLUMNS_RELATORIO_PROCESSAMENTO_CARGAS,
      retiradaDeOriginal: COLUMNS_POS_PAG_RETIRADA_DE_ORIGINAL,
      solicitacaoDocumentos: COLUMNS_POS_PAG_SOLICITACAO_DOCUMENTOS,
      aprovadorSolicitacao: COLUMNS_POS_PAG_APROVADOR_SOLICITACAO
    }[type] || [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas.'
    );
    return null;
  }
}

export const getFilters = (type) => {
  try {
    return {
      relatorio: FIELDS_RELATORIO,
      relatorioFaturamento: FIELDS_RELATORIO_FATURAMENTO,
      acompanharSolicitacao: FIELDS_ACOMPANHAR_SOLICITACAO,
      relatorioRegistroContratoGeral: FIELDS_RELATORIOS_REGISTRO_CONTRATO_GERAL,
      relatorioProtocolo: FIELDS_RELATORIO_PROTOCOLO,
      relatorioProtocoloRealizadoSim: FIELDS_RELATORIO_PROTOCOLO_REALIZADO_SIM,
      relatorioProtocoloRealizadoNao: FIELDS_RELATORIO_PROTOCOLO_REALIZADO_NAO,
      relatorioContratosRecepcionados: FIELDS_RELATORIO_CONTRATOS_RECEPCIONADOS,
      relatorioProcessamentoCargas: FIELDS_RELATORIO_PROCESSAMENTO_CARGAS,
      dashboard: FIELDS_DASHBOARD,
      'analise-retorno-detran': FIELDS_ANALISE_DEVOLUTIVA,
      consultaContrato: FIELDS_POS_PAG_CONSULTA,
      posPagRetiradaDeOriginal: FIELDS_POS_PAG_RETIRADA_DE_ORIGINAL,
      solicitacaoDocumentos: FIELDS_POS_PAG_SOLICITACAO_DOCUMENTOS,
      aprovadorSolicitacao: FIELDS_POS_PAG_APROVADOR_SOLICITACAO
    }[type] || [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os campos.'
    );
    return null;
  }
}

export const cancelarSolicitacaoKit = async (params) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.put('/posPagamento/cancelar-solicitacao-kit',
      { IdDadosKit: params }
    );
    data.success && toast.success('Cancelamento da Solicitação efetuada com sucesso')
    return;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar cancelar a solicitação.'
    );
    return [];
  }
}
export const reenviarSolicitacaoKit = async (params) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.put('/posPagamento/reenviar-solicitacao',
      { IdDadosKit: params }
    );
    data.success && toast.success('Reenvio de Solicitação efetuada com sucesso')
    return;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar reenviar a solicitação.'
    );
    return [];
  }
}

export const getListAcompanharSolicitacao = async (params) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get('/posPagamento/listar-solicitacao-kit', { params: params });
    return data.obj ? data.obj : [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar os dados.'
    );
    return [];
  }
}

export const postFilesSolicitacaoKit = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/posPagamento/salvar-solicitacao-kit', values);
    const { withErrors, withSuccess } = data.msg;
    withErrors.forEach(e => toast.error(e))
    withSuccess.forEach(e => toast.success(e))
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar salvar o kit.');
    return {};
  }
}

export const postFilesRegistroDevolutiva = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/posPagamento/processa-retorno-credenciada', values);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar solicitar retorno DETRAN.');
    return {};
  }
}

export const getCredenciadas = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get('/posPagamento/listar-credenciadas', {
      params: values,
    });
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao buscar credenciadas.');
    return {};
  }
}

export const postCredenciada = async (values) => {
  try {
    const client = await api('mesaveic');
    const data = await client.post('/posPagamento/salvar-credenciada', values);
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao cadastrar credenciada.');
    return {};
  }
}

export const deleteCredenciada = async ({ IdCredenciada }) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.delete(`/posPagamento/deletar-credenciada/${IdCredenciada}`);
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao apagar credenciada.');
    return {};
  }
}

export const downloadKit = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/posPagamento/markFirstDownload',
      values
    );

    if (data.success) {
      
      toast.success('Solicitação efetuada com sucesso');
      return data.obj;

    }
    return toast.error(data?.msg || 'Ocorreu um erro ao tentar solicitar o download do kit.');
  } catch (error) {
    console.log('Error: ', error);
    toast.error(
      'Ocorreu um erro ao efetuar a solicitação.'
    );
    return [];
  }
}

export const getRelatoriosData = async (values) => {
  try {
    const { relatorioPosPag, ...relatorioValues } = values;

    if (!relatorioPosPag) {
      return;
    }
    // if (relatorioPosPag === "Pós-Pagamento - Retirada de Original")
    //   relatorioPosPag = 'retiradaDeOriginal'

    const client = await api('consulta');
    const { data } = await client.get('/relatorioPosPag/consulta', { params: { tipoRelatorio: relatorioPosPag, ...relatorioValues } });

    if (data)
      toast.warn("Para verificar o resultado completo, favor exportar o relatório")

    return data?.obj || [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao buscar os dados do relatório.'
    );
    return [];
  }
}

export const getColumnsAnalitico = async (fila) => {
  try {
    if (fila == 252) {
      return COLUMNS_ANALITICO_POS_CONTRATO_INEXISTENTE;
    }

    return COLUMNS_ANALITICO_POS;
  } catch (error) {
    return [];
  }
};

export const exportAnaliticoExcel = async (values, type) => {
  try {
    const client = await api('mesaveic');
    const urlPost = values.status === "252" ? '/posPagamento/exportarDashboardAnaliticoContratoInexistente' : '/posPagamento/exportarExcelAnalitico';
    const { data } = await client.post(
      urlPost, null,
      {
        responseType: 'arraybuffer',
        params: { ...values, type }
      }
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar exportar o arquivo Excel.');
  }
};

export const exportAnaliticoPDF = async (values, type) => {
  try {
    const client = await api('mesaveic');
    const urlPost = values.status === "252" ? '/posPagamento/exportarDashboardAnaliticoContratoInexistente' : '/posPagamento/exportarPDFAnalitico';
    const { data } = await client.post(urlPost, null,
      {
        responseType: 'arraybuffer',
        params: { ...values, type }
      }
    );
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar exportar o arquivo PDF.');
    return null;
  }
};

export const getDashboardInfo = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get('posPagamento/datasDashboard', { params: { ...values } });
    return data?.obj || [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao buscar os dados do relatório.'
    );
    return [];
  }
}

export const getAnaliseDevolutivaData = async (values) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get('analiseDevolutiva/consulta', { params: { ...values } });
    return data?.obj || [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao buscar os dados.'
    );
    return [];
  }
}

export const getTabsData = async () => {
  try {
    const client = await api('consulta');
    const { data } = await client.get('/posPagamento/registroContrato/tabs');
    return data || [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao buscar os dados.'
    );
    return [];
  }
}

export const getButtonActions = async (params) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      '/posPagamento/registroContrato/actions', { params }
    );
    return data?.obj || [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao buscar os dados.'
    );
    return [];
  }
}

export const getPdfsAnaliseDevolutiva = async (params) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      'parametrizacaoPos/urlKit', { params }
    );
    const ret = data.obj
      ? data.obj.map((element) => {
        return {
          path: element.url,
          tipoCaptura:
            element.dados && element.dados[1] ? element.dados[1].value : 'pdf',
          dataCaptura:
            element.dados && element.dados[3] ? element.dados[3].value : '',
          idDocumento: params.IdDetalheKit,
        };
      })
      : [];

    return ret;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao buscar os dados.'
    );
    return [];
  }
}

export const postDirecionarFila = async (body) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('posPagamento/registro-contrato-direcionar', body)
    return data?.obj || []
  } catch (error) {
    toast.error('Ocorreu um erro ao direcionar')
    return []
  }
}

export const toggleCredenciada = async (params) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.put(
      `posPagamento/toggle-credenciada/${params}`
    );
    return data;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao buscar os dados.'
    );
    return [];
  }
}

export const getContratoData = async (params) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      '/posPagamento/registroContrato', { params }
    );
    return data || [];
  } catch (error) {
    toast.error('Ocorreu um erro ao buscar os dados.');
    return [];
  }
}

// Novo modo de Pós Pagamento
export const listaConsultaDeContrato = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(`/posPagamento/consultarContrato`, {
      params: values,
    });

    return data || [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados.');
    return [];
  }
};

export const consultarProtocolos = async (values) => {
  try {
    const client = await api('consulta');

    const { data } = await client.get(`/protocolo/consultar`, {
      params: values,
    });

    return data || { status: false, obj: [] };
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados.');
    return [];
  }
};

export const getTabsDataWithParams = async (params = undefined) => {

  try {
    const client = await api('consulta');
    const { data } = await client.get(`/contrato/tabs${params.payload.IdMenu ? `?IdMenu=${params.payload.IdMenu}` : ''}`);

    if (data && data.error) {
      toast.error(data.error);
      return [];
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados das tabs.');
    return null;
  }
};

export const enviarEmail = async ({ documents, documentsName, emails, idContrato }) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      `/posPagamento/enviarEmail`,
      { documents, documentsName, emails, idContrato }
    );

    if (data && data.error) {
      toast.error(data.error);
      return [];
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados das tabs.');
    return null;
  }
};

export const downloadDocuments = async ({ documentsName, idContrato }) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(
      `/posPagamento/downloadDocuments`,
      { documentsName, idContrato }
    );

    if (data && data.error) {
      toast.error(data.error);
      return [];
    }

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados das tabs.');
    return null;
  }
};

export const checkContratosCanceladosService = async (contratoSelecionado, numeroDoContrato) => {
  try {

    if (contratoSelecionado.length > 0) {

      if (numeroDoContrato) {
        const client = await api('consulta');
        const { data } = await client.get(
          `/posPagamento/protocolos/cancelados${numeroDoContrato ? `?numeroDoContrato=${numeroDoContrato}` : ''}`,
        );

        if (data !== undefined) {
          if (data.success && Object.keys(data.obj).length !== 0) {
            toast.success(data.msg)
            return data;
          } else {
            toast.warn(data.msg)
            return;
          }
        }
      } else {
        toast.error("Digite o número do contrato cancelado")
      }

    } else {
      toast.error("Nenhum contrato selecionado")
    }

  } catch (error) {
    console.log(error)
    toast.error('Erro ao consultar');
    return null;
  }
};

export const listaConsultaSolicitacao = async (values) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/solicitacaoDocumentos/consulta-solicitacoes`, {
      params: values,
    });

    return data || [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados.');
    return [];
  }
};

// Fim Novo Módulo de Pós